<template>
	<v-layout class="rc-showLoadingPanel" align-center justify-center>
        <v-flex xs12 text-xs-center>
            <v-progress-circular indeterminate color="primary" :size="72" :width="5" style="margin: auto;"></v-progress-circular>
            <p class="mt-2" v-if="tituloLoading"><strong>{{ tituloLoading }}</strong></p>
            <p v-if="subtituloLoading">{{ subtituloLoading }}</p>
        </v-flex>
    </v-layout>
</template>

<script>
	import { Component, Vue } from "vue-property-decorator";
	
	@Component({
		props: {
			tituloLoading : {
				type: String,
				default: null
			},
            subtituloLoading : {
				type: String,
				default: 'Cargando..'
			}
        },
	})
	export default class ShowLoading extends Vue {}
</script>

<style lang="scss" scoped>
	@each $breakpoint in $breakpoints_screen_text{
		@include breakpoint_media_queries($breakpoint){
			@if $breakpoint == "x-large"{
				.rc-showLoadingPanel{
                    height: calc(100vh - 64px);
                }
			}@else if $breakpoint == "large"{
				.rc-showLoadingPanel{
                    height: calc(100vh - 64px);
                }
			}@else if $breakpoint == "medium-to-large"{
				.rc-showLoadingPanel{
                    height: calc(100vh - 64px);
                }
			}@else if $breakpoint == "small-to-medium"{
			    .rc-showLoadingPanel{
                    height: calc(100vh - 48px);
                }
			}@else if $breakpoint == "small"{
                .rc-showLoadingPanel{
                    height: calc(100vh - 56px);
                }
			}
		}
	}
</style>
